<div class="internal-layout-container">
  <app-sidebar-navigation [userInfo]="userInfo$ | async"></app-sidebar-navigation>

  <div class="main-content-area">
    <div class="header flex items-center">
      <!-- Left Section: Header Text -->
      <div class="flex items-center flex-shrink-0 min-w-0">
        <span class="truncate heading-md">{{ headerText$ | async }}</span>
      </div>
    </div>
    <main>
      @if (admin$ | async) {
        <router-outlet></router-outlet>
      } @else {
        <div class="flex items-center justify-center h-full">
          <mat-spinner [diameter]="48"></mat-spinner>
        </div>
      }
    </main>
  </div>
  <cdw-ae-platform-admin-footer></cdw-ae-platform-admin-footer>
</div>
